// extracted by mini-css-extract-plugin
module.exports = {"paymentStyle":"_2Mcq6O2sbhQ1_a30nAfKHE"};